// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__OzKuE","notes":"Notes_notes__2rnF3","note":"Notes_note__kFqSu","markdown":"Notes_markdown__3iqL4"};